var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import { UrlHelper } from '../../helper/UrlWrapper';
import { summaries } from "../../helper/util";
import GLOBAL_VUE from '../../globalVue';
import OrderService from '../../api/OrderService';
import RegexStr from "../../common/RegexStr";
import AddDialog from "./component/GoodAdd.vue";
import Header from "./component/AddHeader.vue";
import TableHeaderToolTip from '../../common/components/TableHeaderToolTip';
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import RequiredMixin from "../../components/renderHeader/RequiredMixin";
import OCRUpload from '../deliver/component/OCRUpload.vue';
var phoneRegex = new RegExp(RegexStr.mobile);
var EStockType;
(function (EStockType) {
    EStockType[EStockType["STOCK"] = 1] = "STOCK";
    EStockType[EStockType["NO_STOCK"] = 2] = "NO_STOCK";
})(EStockType || (EStockType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.data = [];
        _this.formData = {
            order_ctime: new Date(),
            order_arriveddate: new Date(),
            agent_order_code: '',
            supplier_to_business_id: '',
            business_id: '',
            depot_id: '',
            purchasing_agent: '',
            order_icomment: '',
            from_system: 4,
            shop_id: null,
            shop_name: '',
            organ_id: '',
            organ_name: '',
            purchasing_agent_phone: '',
            is_modify_oamount: 1,
            is_modify_uprice: 1,
            is_show_uprice: 1
        };
        _this.enumStatus = EHandleStatus;
        _this.handleStatus = EHandleStatus.Add;
        _this.eStockType = EStockType;
        _this.orderid = '';
        _this.pageUse = '';
        _this.targetOrderId = '';
        _this.handletype = 0;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.billsSource = [];
        _this.uploadShow = false;
        _this.isOpenOCR = false;
        _this.goods_ids = [];
        _this.err_codes = [42, 43, 44, 45];
        _this.hasEditOperate = false;
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.created = function () {
        this.OrderService = OrderService.getInstance();
        if (this.orderid) {
            this.getDetail();
        }
        else if (this.pageUse == 'copy' && this.targetOrderId) {
            this.createDetailByCopy();
        }
        this.getIsOpenOCR();
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 300;
        }, 300);
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid
        };
        return this.OrderService.getGoodList(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            data.shop_id = data.shop_id == 0 ? null : data.shop_id;
            _this.formData = Object.assign({}, _this.formData, {
                order_arriveddate: new Date(data.order_arriveddate),
                order_ctime: new Date(data.order_ctime),
                agent_order_code: data.agent_order_code,
                business_id: data.business_id,
                supplier_to_business_id: data.supplier_to_business_id,
                depot_id: data.depot_id,
                purchasing_agent: data.purchasing_agent,
                order_icomment: data.order_icomment,
                from_system: data.from_system,
                from_system_name: data.from_system_name,
                shop_id: data.shop_id,
                shop_name: data.shop_name,
                organ_id: data.organ_id,
                organ_name: data.organ_name,
                purchasing_agent_phone: data.purchasing_agent_phone || '',
                order_code: data.order_code,
                is_modify_oamount: data.is_modify_oamount,
                is_modify_uprice: data.is_modify_uprice,
                is_show_uprice: data.is_show_uprice
            });
            _this.data = data.items || [];
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.createDetailByCopy = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.targetOrderId
        };
        this.OrderService.copyOrder(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            var nowDate = new Date();
            data.shop_id = data.shop_id == 0 ? null : data.shop_id;
            _this.formData = Object.assign({}, _this.formData, {
                order_arriveddate: new Date(nowDate.getTime() + 24 * 60 * 60 * 1000),
                order_ctime: nowDate,
                agent_order_code: data.agent_order_code,
                business_id: data.business_id,
                depot_id: data.depot_id,
                purchasing_agent: data.purchasing_agent,
                order_icomment: data.order_icomment,
                from_system: data.from_system,
                shop_id: data.shop_id,
                organ_id: data.organ_id,
                purchasing_agent_phone: data.purchasing_agent_phone || '',
                order_code: data.order_code,
                is_modify_oamount: data.is_modify_oamount,
                is_modify_uprice: data.is_modify_uprice,
                is_show_uprice: data.is_show_uprice
            });
            _this.data = data.items || [];
            if (data.msg_data.length > 0) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: data.msg_data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_money", "order_detail_tax_money", 'order_detail_reduction_money', "order_detail_no_tax_money"];
        sums = summaries(param, showSum);
        sums[0] = '';
        sums[1] = '合计';
        return sums;
    };
    default_1.prototype.audit = function (params) {
        var _this = this;
        var msg = '审核后，订单不可更改，且默认为待发货状态，请确认是否继续？';
        var orderIds = this.orderid;
        var paramsData = {
            ids: params && params.orderIds || orderIds,
            code: params && params.code || '',
            type: params && params.type || ''
        };
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            if (res == 'confirm') {
                if (_this.hasEditOperate) {
                    _this.saveAjax().then(function () {
                        _this.auditAjax(paramsData);
                    });
                }
                else {
                    _this.auditAjax(paramsData);
                }
            }
        }).catch(function () { });
    };
    default_1.prototype.auditAjax = function (paramsData) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.OrderService.review(paramsData).then(function (res) {
            var errCode = res.data.code;
            if (_this.err_codes.indexOf(res.data.code) > -1) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350
                }).instance;
                instance.$on("artMsglist:ok", function (data) {
                    _this.auditAjax({
                        ids: paramsData.ids,
                        code: res.data.code,
                        type: data || ''
                    });
                });
            }
            else {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getDetail();
                }
                else {
                    _this.$message.success(res.data.msg || "审核成功");
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.search(_this.opener.searchParams);
                        }
                    }, 500);
                }
            }
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.save = function () {
        var _this = this;
        this.saveAjax().then(function (res) {
            _this.$message.success(res.data.msg);
            setTimeout(function () {
                GLOBAL_VUE.$emit("closeTab", _this);
                if (_this.opener) {
                    if (_this.pageUse == 'copy') {
                        if (_this.opener.search) {
                            _this.opener.search(_this.opener.searchParams);
                        }
                    }
                    else {
                        _this.opener.search(_this.opener.searchParams);
                    }
                }
            }, 500);
            if (_this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(["_trackEvent", '修改订货单', '保存', '保存']);
            }
            else {
                window._czc.push(["_trackEvent", '添加订货单', '保存', '保存']);
            }
        }, function (err) {
            console.log(err);
        });
    };
    default_1.prototype.saveAjax = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            console.log("saveAjax");
            if (!_this.checkSave()) {
                return reject('error');
            }
            var formData = _this.formData;
            var params = {
                order_ctime: formData.order_ctime.format('yyyy-MM-dd'),
                business_id: formData.business_id,
                shop_id: formData.shop_id,
                order_arriveddate: formData.order_arriveddate.format('yyyy-MM-dd'),
                agent_order_code: formData.agent_order_code,
                purchasing_agent: formData.purchasing_agent,
                order_icomment: formData.order_icomment,
                purchasing_agent_phone: formData.purchasing_agent_phone,
                organ_id: formData.organ_id,
                from_system: formData.from_system,
                data: JSON.stringify(_this.data.map(function (v) {
                    return {
                        goods_id: v.goods_id || v.supplier_goods_id,
                        goods_format_id: v.goods_format_id,
                        order_detail_amount: v.order_detail_amount,
                        order_detail_uprice: v.order_detail_uprice,
                        order_detail_icomment: v.order_detail_icomment,
                        goods_price_id: v.goods_price_id,
                        order_gift_amount: v.order_gift_amount
                    };
                }))
            };
            if (_this.orderid) {
                params = Object.assign({}, params, { order_id: _this.orderid });
            }
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.OrderService.addSave(params).then(function (res) {
                loadingInstance.close();
                return resolve(res);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
                return reject(err);
            });
        });
    };
    default_1.prototype.checkSave = function () {
        if (!this.canHandleGoods()) {
            return false;
        }
        var flag = true, msg = [];
        this.data.map(function (row) {
            if ((!row.order_detail_amount && row.order_detail_amount !== 0) || row.order_detail_amount <= 0) {
                flag = false;
                msg.push('采购量必填，采购量大于0');
            }
            if (row.order_detail_uprice && row.order_detail_uprice < 0) {
                flag = false;
                msg.push('单价大于等于0');
            }
        });
        if (!flag) {
            this.$message.warning('货品信息不可为空，单价大于等于0，采购量大于0。');
            return false;
        }
        return true;
    };
    default_1.prototype.canHandleGoods = function () {
        if (!this.formData.shop_id || !this.formData.business_id) {
            this.$message.warning("请选择订货门店");
            return false;
        }
        if (!this.formData.order_arriveddate) {
            this.$message.warning("请选择到货日期");
            return false;
        }
        return true;
    };
    default_1.prototype.importFile = function () {
        if (!this.canHandleGoods()) {
            return;
        }
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    default_1.prototype.emptyOrderDetail = function () {
        this.data = [];
    };
    default_1.prototype.handleGoodsFieldDiffOrderField = function (res, type) {
        return res.map(function (v) {
            if (undefined == v.goods_price_id) {
                return v;
            }
            console.log(999, v.goods_price_id);
            var tmp = {
                goods_format_id: v.goods_format_id,
                supplier_goods_format: v.supplier_goods_format || v.goods_format_name,
                goods_price_id: v.goods_price_id,
                order_remaining_stock: v.order_remaining_stock,
                goods_unit: v.goods_unit || v.sales_unit,
                sales_unit_coefficient: v.sales_unit_coefficient,
                sales_unit_id: v.sales_unit_id,
                supplier_goods_code: v.supplier_goods_code,
                supplier_goods_id: v.supplier_goods_id,
                supplier_goods_name: v.supplier_goods_name,
                supplier_goods_pinyin: v.supplier_goods_pinyin,
                order_detail_tax_rate: v.order_detail_tax_rate,
                order_detail_uprice: v.order_detail_uprice,
                order_detai_after_money: v.order_detai_after_money || '',
                order_detail_icomment: v.order_detail_icomment || '',
                order_detail_amount: v.order_detail_amount || '',
                order_detail_money: v.order_detail_money,
                order_detail_tax_money: v.order_detail_tax_money,
                order_detail_no_tax_money: v.order_detail_no_tax_money,
                supplier_goods_bar_code: v.supplier_goods_bar_code,
            };
            if (type == 'import') {
                tmp.order_detail_uprice = v.goods_price;
            }
            return tmp;
        });
    };
    default_1.prototype.toAddGood = function () {
        var _this = this;
        if (!this.canHandleGoods()) {
            return;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                business_id: this.formData.business_id,
                supplier_to_business_id: this.formData.supplier_to_business_id,
                shop_id: this.formData.shop_id
            }
        }, {
            title: "添加货品",
            width: 900,
            height: 550
        });
        dialog.instance.$on("submit", function (res) {
            console.log('res', res);
            res = _this.handleGoodsFieldDiffOrderField(res);
            _this.data = res;
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(["_trackEvent", '修改订货单', '添加货品', '添加货品']);
            }
            else {
                window._czc.push(["_trackEvent", '添加订货单', '添加货品', '添加货品']);
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择货品");
            return;
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(["_trackEvent", '修改订货单', '删除货品', '删除货品']);
            }
            else {
                window._czc.push(["_trackEvent", '添加订货单', '删除货品', '删除货品']);
            }
        }, function (err) { });
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        if (type === 'order_gift_amount') {
            if (row.order_gift_amount < 0) {
                row.order_gift_amount = Math.abs(row.order_gift_amount);
            }
            else if (row.order_gift_amount > 0) {
                var detailAmountStr = row.order_gift_amount.toString();
                var pointIndex = detailAmountStr.indexOf('.');
                if (pointIndex > -1) {
                    row.order_gift_amount = detailAmountStr.slice(0, pointIndex + Number(this.amountScale) + 1);
                }
            }
        }
        if (type == 'order_detail_amount' || type == 'order_detail_uprice') {
            if (row.order_detail_amount < 0) {
                row.order_detail_amount = Math.abs(row.order_detail_amount);
            }
            else if (row.order_detail_amount > 0) {
                var detailAmountStr = row.order_detail_amount.toString();
                var pointIndex = detailAmountStr.indexOf('.');
                if (pointIndex > -1) {
                    row.order_detail_amount = detailAmountStr.slice(0, pointIndex + Number(this.amountScale) + 1);
                }
            }
            if (row.order_detail_uprice < 0) {
                row.order_detail_uprice = Math.abs(row.order_detail_uprice);
            }
            else if (row.order_detail_uprice > 0) {
                var detailUpricetStr = row.order_detail_uprice.toString();
                var pointIndex = detailUpricetStr.indexOf('.');
                if (pointIndex > -1) {
                    row.order_detail_uprice = detailUpricetStr.slice(0, pointIndex + 5);
                }
            }
            if (row.order_detail_amount > 0 && row.order_detail_uprice >= 0) {
                row.order_detail_money = new Number(+row.order_detail_amount * +row.order_detail_uprice).toFixedNoZero(2);
                row.order_detail_tax_money = new Number((+row.order_detail_money / (1 + +row.order_detail_tax_rate / 100) * +row.order_detail_tax_rate / 100)).toFixedNoZero(4);
                row.order_detail_no_tax_money = new Number(+row.order_detail_money - +row.order_detail_tax_money).toFixedNoZero(4);
            }
            else {
                row.order_detail_money = "";
                row.order_detail_tax_money = "";
                row.order_detail_no_tax_money = "";
            }
        }
    };
    default_1.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (fileType == "xlsx" || fileType == "xls") {
            if (!this.loadingInstance)
                this.loadingInstance = Loading.service({ fullscreen: true });
            return;
        }
        this.$message.error("文件只能是xlsx或xls");
        return false;
    };
    default_1.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = '';
            url = "supplierclientapi/stockinit/export_error?import_id=" + data.import_id;
            this.data = (this.handleGoodsFieldDiffOrderField(data.goods_list || [], 'import')).concat(this.data);
            if (this.handleStatus === EHanldeStatus.Edit && data.goods_list && data.goods_list.length) {
                this.saveAjax();
            }
            if (this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(["_trackEvent", '修改订货单', '导入货品', '导入货品']);
            }
            else {
                window._czc.push(["_trackEvent", '添加订货单', '导入货品', '导入货品']);
            }
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    default_1.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    default_1.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    default_1.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    default_1.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    default_1.prototype.openOCR = function () {
        this.uploadShow = true;
    };
    default_1.prototype.cancelDio = function () {
        this.uploadShow = false;
    };
    default_1.prototype.importGood = function (selectGood) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.uploadShow = false;
                        if (!selectGood.length) return [3, 3];
                        if (!(this.handleStatus === EHandleStatus.Edit)) return [3, 2];
                        return [4, this.deliverService.getDetailAddGoods({
                                order_id: this.order_id,
                                data: JSON.stringify(selectGood),
                            }).then(function (res) {
                                selectGood = res.data.data;
                            }).catch(function (err) {
                                _this.$message.error(err.msg || err.message);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        selectGood.forEach(function (item) {
                            item.supplier_goods_format = item.supplier_goods_format || item.goods_format_name;
                            item.order_detail_amount = item.amount || 0;
                            _this.data.push(item);
                        });
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    default_1.prototype.getIsOpenOCR = function () {
        var _this = this;
        this.commonService.getIsOpenOCR()
            .then(function (res) {
            if (res.data.success) {
                _this.isOpenOCR = !!(Array.isArray(res.data.data) && res.data.data.includes(3));
            }
            console.log('res>>>', res);
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1 = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'ocr-upload': OCRUpload,
                'add-header': Header,
                TableHeaderToolTip: TableHeaderToolTip
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }), { ocrParams: function () {
                    var goods_format_ids = this.selections && this.selections.length ? this.selections.map(function (item) { return item.goods_format_id; }).join(',') : '';
                    var supplier_to_business_id = this.formData && this.formData.supplier_to_business_id ? this.formData.supplier_to_business_id : '';
                    return { goods_format_ids: goods_format_ids, supplier_to_business_id: supplier_to_business_id };
                },
                amountScale: function () {
                    return this.$store.getters.getBusinessConfig(this.formData.business_id, 'amount_scale', '2');
                } }),
            watch: {
                formData: {
                    handler: function (val, oldVal) {
                        if (oldVal && oldVal.order_code) {
                            this.hasEditOperate = true;
                        }
                    },
                    deep: true
                },
                data: {
                    handler: function (val, oldVal) {
                        if (oldVal && oldVal.length) {
                            this.hasEditOperate = true;
                        }
                    },
                    deep: true
                }
            },
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "税额=含税金额/(1+税率)*税率",
                            placement: "bottom"
                        }
                    }, '税额');
                }
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
